export const Common = {
  Choose: 'Vyberte',
  No: 'Ne',
  Yes: 'Ano',
};
